import { useState, useEffect, useCallback, useContext } from "react";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import { UIContext } from "../../../../../contexts";
import { Enrollment } from "../../../../../@types/enrollment.types";
import useRouteParam from "../../../../../hooks/useRouteParam";
import { api } from "../../../../../utils/api";
import EnrollmentApprovalGrid from "./EnrollmentApprovalGrid";
import { trackPromise } from "react-promise-tracker";
import { PaginationTypes } from "../../../../../@types/pagination.types";
import { DatePicker } from "@material-ui/pickers";

const EnrollmentApproval = (): JSX.Element => {
	const [enrollments, setEnrollments] = useState<Enrollment[]>([]);
	const [pagination, setPagination] = useState<PaginationTypes>({
		currentPage: 1,
		pageCount: undefined
	});
	const { setDashboardHeader } = useContext(UIContext);
	const queryGroupNumber = useRouteParam("gn");
	const [filterSchema, setFilterSchema] = useState({
		member_id: { value: null, type: null },
		first_name: { value: null, type: null },
		last_name: { value: null, type: null },
		enrollment_date: { value: null, type: null }
		// plan_name: { value: null, type: null },
		// location_number: { value: null, type: null },
		// plan_code: { value: null, type: null },
		// enrollment_status: { value: null, type: null }
	});

	const { currentPage } = pagination;

	const getEnrollments = useCallback(async () => {
		if (!queryGroupNumber) return;

		const filters = Object.fromEntries(
			Object.entries(filterSchema)
				.filter(([_, { value }]) => value !== null && value !== "")
				.map(([k, v]) => {
					if (k === "employee.first_name") return ["first_name", v.value];
					if (k === "employee.last_name") return ["last_name", v.value];
					if (k === "employee.member_id") return ["member_id", v.value];
					return [k, v.value];
				})
		);

		const response = await trackPromise(
			api.enrollments.getNotActiveEnrollmentsByGroup(queryGroupNumber as number, currentPage, 15, filters)
		);

		if (response) {
			const { enrollments, autoApproveEnrollments, nonEnrollments, pagination } = response;
			setEnrollments([...enrollments, ...autoApproveEnrollments, ...nonEnrollments]);
			if (pagination) {
				//eslint-disable-next-line
				setPagination((prev) => ({
					...prev,
					pageCount: pagination.pageCount,
					currentPage: pagination.currentPage
				}));
			}
		}
	}, [queryGroupNumber, currentPage, filterSchema]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.employer_enrollment_approval);
	}, [setDashboardHeader]);

	useEffect(() => {
		getEnrollments();
	}, [getEnrollments]);

	const handlePageChange = useCallback((_: unknown, page: number) => {
		//eslint-disable-next-line
		setPagination((prev) => ({
			...prev,
			currentPage: page
		}));
	}, []);

	useEffect(() => {
		getEnrollments();
	}, [getEnrollments, filterSchema]);

	return (
		<EnrollmentApprovalGrid
			enrollments={enrollments}
			currentPage={pagination.currentPage}
			pageCount={pagination.pageCount}
			handlePageChange={handlePageChange}
			filterSchema={filterSchema}
			setFilterSchema={setFilterSchema}
		/>
	);
};

export default EnrollmentApproval;
